import { render, staticRenderFns } from "./teamTarget.vue?vue&type=template&id=39b9aa0f&"
import script from "./teamTarget.vue?vue&type=script&lang=js&"
export * from "./teamTarget.vue?vue&type=script&lang=js&"
import style0 from "./teamTarget.vue?vue&type=style&index=0&id=39b9aa0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports